export default __webpack_public_path__ + "media/79597af477a84fb878c533f7a31b8c01e1c3c8cbd9d0a49930f521be6311dc44.svg";